import produce from "immer";
import {
  SORT_CALCUL_MODIFIED_AT_DESC,
  SORT_FOLDER_MODIFIED_AT_DESC,
} from "../../../common/constants/sort";
import {
  CHANGE_FOLDER_CALCULS_PAGE,
  CHANGE_FOLDER_CALCULS_SEARCH,
  CHANGE_FOLDER_CALCULS_SORT,
  CHANGE_FOLDERS_PAGE,
  CHANGE_FOLDERS_SORT,
  CLEAR_FOLDER_INFOS,
  DELETE_FOLDER_SUCCESS,
  ENABLE_FOLDER_LOADER,
  GET_ALL_USER_FOLDERS_FAILED,
  GET_ALL_USER_FOLDERS_SUCCESS,
  GET_ARCHIVED_CALCULS_FAILED,
  GET_ARCHIVED_CALCULS_SUCCESS,
  GET_FOLDER_CALCULS_FAILED,
  GET_FOLDER_CALCULS_SUCCESS,
  GET_FOLDER_FAILED,
  GET_FOLDER_SUCCESS,
  GET_USER_FOLDERS_FAILED,
  GET_USER_FOLDERS_SUCCESS,
  MANAGE_CALCULS_FOLDERS_FAILED,
  MANAGE_CALCULS_FOLDERS_SUCCESS,
  POST_FOLDER_SUCCESS,
  UPDATE_FOLDER_CALCULS_FILTERS,
  UPDATE_FOLDER_CALCULS_LIMIT,
  UPDATE_FOLDER_SUCCESS,
  UPDATE_FOLDERS_LIMIT,
} from "../constants";
import {
  defaultCalculsFilters,
  DELETE_CALCUL_SUCCESS,
  UPDATE_CALCUL_ATTRIBUTES_SUCCESS,
} from "../../calcul/constants";
import {
  DEFAULT_PAGINATION_LIMIT,
  normalizePaginationLimit,
} from "../../../common/constants/pagination";

const initialState = {
  folders: [],
  folder: {},
  isLoading: false,
  sort: SORT_FOLDER_MODIFIED_AT_DESC,
  limit: DEFAULT_PAGINATION_LIMIT,
  currentPage: 1,
  total: 0,
  folderReports: {},
  allFolders: [],
  folderCalculs: [],
  folderCalculsCurrentPage: 1,
  folderCalculsLimit: DEFAULT_PAGINATION_LIMIT,
  folderCalculsTotal: 0,
  folderCalculsSort: SORT_CALCUL_MODIFIED_AT_DESC,
  folderCalculsSearch: "",
  folderCalculsFilters: defaultCalculsFilters,
};

const foldersReducer = produce((draft = initialState, action) => {
  switch (action.type) {
    case ENABLE_FOLDER_LOADER:
      draft.isLoading = true;
      break;
    case GET_USER_FOLDERS_SUCCESS:
      draft.folders = action.payload.data;
      draft.total = action.payload.total;
      draft.isLoading = false;
      break;
    case GET_USER_FOLDERS_FAILED:
      draft.folders = [];
      draft.total = 0;
      draft.isLoading = false;
      break;
    case CHANGE_FOLDERS_SORT:
      draft.currentPage = 1;
      draft.sort = action.sort;
      draft.isLoading = true;
      break;
    case CHANGE_FOLDERS_PAGE:
      draft.isLoading = true;
      draft.currentPage = action.page;
      break;
    case UPDATE_FOLDERS_LIMIT:
      draft.isLoading = true;
      draft.currentPage = 1;
      draft.limit = normalizePaginationLimit(action.limit);
      break;
    case POST_FOLDER_SUCCESS:
      draft.isLoading = false;
      break;
    case UPDATE_FOLDER_SUCCESS:
      draft.folder.label = action.payload.label;
      draft.isLoading = false;
      break;
    case DELETE_FOLDER_SUCCESS:
      draft.isLoading = false;
      break;
    case GET_ALL_USER_FOLDERS_SUCCESS:
      draft.allFolders = action.payload.data;
      draft.isLoading = false;
      break;
    case GET_ALL_USER_FOLDERS_FAILED:
      draft.allFolders = [];
      draft.isLoading = false;
      break;
    case MANAGE_CALCULS_FOLDERS_SUCCESS:
    case MANAGE_CALCULS_FOLDERS_FAILED:
      draft.isLoading = false;
      break;
    case CHANGE_FOLDER_CALCULS_SORT:
      draft.folderCalculsCurrentPage = 1;
      draft.folderCalculsSort = action.sort;
      draft.isLoading = true;
      break;
    case CHANGE_FOLDER_CALCULS_PAGE:
      draft.isLoading = true;
      draft.folderCalculsCurrentPage = action.page;
      break;
    case UPDATE_FOLDER_CALCULS_LIMIT:
      draft.isLoading = true;
      draft.folderCalculsCurrentPage = 1;
      draft.folderCalculsLimit = normalizePaginationLimit(action.limit);
      break;
    case GET_FOLDER_CALCULS_SUCCESS:
      draft.folderCalculs = action.payload.data;
      draft.folderCalculsTotal = action.payload.total;
      draft.isLoading = false;
      break;
    case GET_FOLDER_CALCULS_FAILED:
      draft.folderCalculs = [];
      draft.folderCalculsTotal = 0;
      draft.isLoading = false;
      break;
    case GET_FOLDER_SUCCESS:
      draft.folder = action.payload;
      draft.isLoading = false;
      break;
    case GET_FOLDER_FAILED:
      draft.folder = {};
      draft.isLoading = false;
      break;
    case GET_ARCHIVED_CALCULS_SUCCESS:
      draft.folderCalculs = action.payload.data;
      draft.folderCalculsTotal = action.payload.total;
      draft.isLoading = false;
      break;
    case GET_ARCHIVED_CALCULS_FAILED:
      draft.folderCalculs = [];
      draft.folderCalculsTotal = 0;
      draft.isLoading = false;
      break;
    case DELETE_CALCUL_SUCCESS:
      draft.folderCalculs = draft.folderCalculs.filter(
        (calcul) => calcul._id !== action.payload._id,
      );
      draft.folderCalculsTotal -= 1;
      break;
    case CHANGE_FOLDER_CALCULS_SEARCH:
      draft.isLoading = true;
      draft.folderCalculsCurrentPage = 1;
      draft.folderCalculsSearch = action.search;
      break;
    case UPDATE_CALCUL_ATTRIBUTES_SUCCESS:
      updateCalculInFolderCalculs(draft, action.payload);
      break;
    case UPDATE_FOLDER_CALCULS_FILTERS:
      draft.isLoading = true;
      draft.folderCalculsCurrentPage = 1;
      draft.folderCalculsFilters = action.filters;
      break;
    case CLEAR_FOLDER_INFOS:
      draft.folderCalculs = [];
      draft.folder = {};
      draft.folderCalculsTotal = 0;
      break;
    default:
      return draft;
  }
});

function updateCalculInFolderCalculs(draft, payload) {
  const index = draft.folderCalculs.findIndex(
    (calcul) => calcul._id === payload._id,
  );
  if (index !== -1) {
    Object.assign(draft.folderCalculs[index], payload);
  }
}

export default foldersReducer;
